export default __webpack_public_path__ + "88ef615968bd48a7c5a3a88a28634c28.png";